import { actionTypes } from '.'

export const setMode = (mode) => (dispatch) => {
  dispatch({
    type: actionTypes.SET_MODE,
    payload: mode
  })
}
